<div *ngIf="toastMessageService.message" class="message-toast">
  <nz-alert
    class="message-alert"
    nzBanner="true"
    [nzIconType]="toastMessageService.iconType"
    [nzMessage]="toastMessageService.message"
    [nzType]="toastMessageService.messageType"
  ></nz-alert>
</div>
